<template>
  <div class="">
    <!-- main banner -->
    <div
      v-if="headerInfo"
      id="home-banner"
      class="
        container-fluid
        px-0
        p-md-1
        d-flex
        flex-column
        justify-content-end
        align-items-center
      "
    >
      <!-- <div id="infinity" class="w-100 h-100 text-center">
      <img :src="infinity" alt="" class="w-75" />
    </div> -->
      <div
        id="main"
        class="h-100 text-center animate__delay-3s mb-5"
        :class="{ animate__zoomIn: !isLoading }"
        :style="`background-image: url(//www.animlab.yuntech.edu.tw/upload/2021/header/${headerInfo.main_image})`"
        data-tilt
        data-tilt-full-page-listening
        data-tilt-scale="1.03"
      ></div>
      <div
        id="deco"
        class="position-absolute animate__animated animate__delay-3s"
        :class="{ animate__zoomIn: !isLoading }"
      >
        <img
          id="deco-img"
          :src="`//www.animlab.yuntech.edu.tw/upload/2021/header/${headerInfo.deco_image}`"
          alt=""
          data-tilt-full-page-listening
          @load="decoLoadHandler"
        />
      </div>
      <div
        v-if="headerInfo && headerInfo.cta_title"
        class="
          call-to-action
          d-flex
          flex-column-reverse flex-md-row
          align-items-center
        "
      >
        <div class="old-h3-bold">{{ headerInfo.cta_title }}</div>
        <a
          :href="headerInfo.cta_link"
          class="group-link align-items-center d-inline-flex tag-link"
          >{{ headerInfo.cta_link_text
          }}<img class="link ms-1" :src="linkArrow" alt=""
        /></a>
      </div>
      <div id="scroll-hint">
        <img :src="scrollUp" alt="向下捲動" class="d-none d-md-inline w-100" />
        <img :src="upup" alt="向下捲動" class="d-md-none w-100" />
      </div>
    </div>
    <div class="home container-md page">
      <div class="row">
        <div class="col-3 position-relative d-none d-lg-block">
          <div :class="{ fixed: isFixed }">
            <SideMenu
              :menu="menu[$route.name]"
              :section="curSection"
            ></SideMenu>
          </div>
        </div>
        <div class="col-12 col-lg-9">
          <!-- news scroll block -->
          <div class="mobile-h3 d-md-none text-center mb-3">最新消息</div>
          <section id="news" ref="newssec">
            <div class="news-wrapper carousel__item">
              <template v-for="n in news" :key="n.id">
                <NewsArticle class="d-inline-block news-article" :news="n" />
              </template>
            </div>
            <div class="arrows text-end d-flex justify-content-end">
              <button class="flex-center scroll-btn scroll-left">
                <img :src="arrowLeft" alt="" />
              </button>
              <button class="flex-center scroll-btn scroll-right">
                <img :src="arrowRight" alt="" />
              </button>
            </div>
          </section>

          <!-- share -->
          <section
            id="share"
            class="text-center d-none d-md-block"
            ref="sharesec"
          >
            <div class="row row-grid">
              <div
                v-for="exp in experiences"
                :key="exp.id"
                class="col-12 col-md-6"
              >
                <div class="card w-100 block-wrap" style="">
                  <div class="card-body">
                    <a :href="exp.link">
                      <div
                        class="exp-img"
                        :style="`background-image: url(//www.animlab.yuntech.edu.tw/upload/2021/exp/${exp.image})`"
                      ></div>
                    </a>
                    <h5 class="card-title">{{ exp.title }}</h5>
                    <div
                      class="card-text text-start sharing-content"
                      v-html="exp.content"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- random participants -->
          <section id="participants" class="d-none d-md-block" ref="partsec">
            <div class="row row-grid two-column">
              <div
                class="col-12 col-md-6"
                v-for="p in talentList"
                :key="p.name"
              >
                <Participant :info="p" />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VanillaTilt from 'vanilla-tilt';
import OverlayScrollbars from 'overlayscrollbars/js/OverlayScrollbars.min';
import { ref } from 'vue';
import { useElementVisibility } from '@vueuse/core';

import { menu } from '@/assets/js/menu';

import SideMenu from '@/components/global/SideMenu.vue';
import NewsArticle from '@/components/home/NewsArticle.vue';
import Participant from '@/components/home/Participant.vue';
// import banner from '@/assets/img/banner.png';
// import logoBanner from '@/assets/img/infinity.png';
// import logoBanner from '@/assets/img/logo-banner.png';
import scrollUp from '@/assets/img/scroll_up.svg';
import upup from '@/assets/img/upup.svg';
import linkArrow from '@/assets/img/link_arrow_w.png';
import arrowLeft from '@/assets/img/arrow-left.svg';
import arrowRight from '@/assets/img/arrow-right.svg';

// temp images
// import pic1 from '@/assets/img/image_placeholder.png';
// import pic2 from '@/assets/img/image_placeholder2.png';
// import pic3 from '@/assets/img/image_placeholder3.png';
// import pic4 from '@/assets/img/image_placeholder4.png';
import share from '@/assets/img/share.png';
// import deco from '@/assets/img/deco2.png';

// api
import { getNewsList } from '@/api/news';
import { getExpList } from '@/api/experience';
import { getHeader } from '@/api/header';
import { getTalentList, talentCount } from '@/api/talent';
import store from '@/store';

export default {
  name: 'Home',
  components: {
    SideMenu,
    NewsArticle,
    Participant,
  },
  setup() {
    const newssec = ref(null);
    const sharesec = ref(null);
    const partsec = ref(null);
    const newsIsVisible = useElementVisibility(newssec);
    const shareIsVisible = useElementVisibility(sharesec);
    const partIsVisible = useElementVisibility(partsec);
    return {
      newssec,
      sharesec,
      partsec,
      newsIsVisible,
      shareIsVisible,
      partIsVisible,
    };
  },
  data() {
    return {
      scrollUp,
      arrowLeft,
      arrowRight,
      upup,
      linkArrow,
      share,
      // deco,
      menu,
      isFixed: true,
      // isFullHeader: true,
      headerInfo: null,
      news: null,
      experiences: null,
      talentList: null,
      // info: [
      //   {
      //     img: pic1, name: '廖恬敏', title: '獨立字體設計師', tags: ['99年度'],
      //   },
      //   {
      //     img: pic2, name: '李子強', title: '雲科大數媒系 助理教授', tags: ['95年度'],
      //   },
      //   {
      //     img: pic3, name: '陳輝泰', title: 'Lippincott 資深設計師', tags: ['102年度'],
      //   },
      //   {
      //     img: pic4, name: '彭冠傑', title: '博物映項 藝術總監', tags: ['102年度'],
      //   },
      // ],
      settings: {
        className: 'os-theme-dark',
        sizeAutoCapable: true,
        paddingAbsolute: true,
        scrollbars: {
          clickScrolling: true,
          visibility: 'auto',
        },
        callbacks: {
          onScroll() {
            if (this.scroll().position.x === 0) {
              document.getElementById('news').classList.remove('left-fade');
            } else {
              document.getElementById('news').classList.add('left-fade');
            }
          },
          onInitialized() {
          },
        },
      },
      curSection: '最新消息',
      pos: {
        top: 0, left: 0, x: 0, y: 0,
      },
    };
  },
  computed: {
    loadComplete() {
      return this.headerInfo && this.news && this.experiences;
    },
    isLoading() {
      return this.$store.getters.getLoadingState;
    },
    showInfiniteLoading() {
      return this.$store.getters.getInfiniteLoading;
    },
  },
  watch: {
    loadComplete(newValue) {
      if (newValue) {
        setTimeout(() => {
          document.querySelector('.os-viewport').addEventListener('mousedown', this.mouseDownHandler);
          OverlayScrollbars(document.querySelectorAll('.sharing-content'), this.settings);
          VanillaTilt.init(document.querySelector('#main'));
          store.commit('setLoadingState', { status: false });
          store.commit('setInfiniteLoading', { status: true });
        }, 1000);
      }
    },
  },
  methods: {
    getPosition(element) {
      let e = element;
      let x = 0;
      let y = 0;
      // 搭配上面的示意圖可比較輕鬆理解為何要這麼計算
      while (e) {
        x += e.offsetLeft - e.scrollLeft + e.clientLeft;
        y += e.offsetTop - e.scrollLeft + e.clientTop;
        e = e.offsetParent;
      }
      return { x, y };
    },
    mainLoadHandler() {
      VanillaTilt.init(document.querySelector('#main'));
    },
    decoLoadHandler() {
      VanillaTilt.init(document.querySelector('#deco-img'));
    },
    mouseDownHandler(e) {
      const ele = document.querySelector('.os-viewport');
      this.pos = {
        // The current scroll
        left: ele.scrollLeft,
        top: ele.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      };
      ele.style.cursor = 'grabbing';
      ele.style.userSelect = 'none';
      ele.addEventListener('mousemove', this.mouseMoveHandler);
      ele.addEventListener('mouseup', this.mouseUpHandler);
      ele.addEventListener('mouseleave', this.mouseUpHandler);
    },
    mouseMoveHandler(e) {
      // How far the mouse has been moved
      const dx = e.clientX - this.pos.x;
      const dy = e.clientY - this.pos.y;

      const ele = document.querySelector('.os-viewport');
      ele.scroll({ x: this.pos.top - dy, y: this.pos.left - dx }, 500);
      // Scroll the element
      ele.scrollTop = this.pos.top - dy;
      ele.scrollLeft = this.pos.left - dx;
    },
    mouseUpHandler() {
      const ele = document.querySelector('.os-viewport');
      ele.removeEventListener('mousemove', this.mouseMoveHandler);
      ele.style.cursor = 'grab';
      ele.style.removeProperty('user-select');
    },
    sideMenuOnScroll() {
      // const homeBannerHeight = (document.getElementById('home-banner')) ? document.getElementById('home-banner').offsetHeight : 0;
      // const bannerHeight = homeBannerHeight + document.getElementById('main-nav').offsetHeight;
      // this.isFixed = window.scrollY > homeBannerHeight;

      const newsPos = this.getPosition(document.getElementById('news'));
      const sharePos = this.getPosition(document.getElementById('share'));
      // const partPos = this.getPosition(document.getElementById('participants'));
      if (window.innerHeight + window.scrollY >= document.body.scrollHeight - 600) {
        this.curSection = '歸國學員特寫';
      } else if (window.scrollY + 400 > sharePos.y) {
        this.curSection = '海外學員分享';
      } else if (window.scrollY + 400 > newsPos.y) {
        this.curSection = '最新消息';
      }
    },
  },
  created() {
    getHeader().then((response) => {
      this.headerInfo = response;
    });
    let filter = { order: 'display_at desc', where: { display_at: { lt: new Date() } } };
    getNewsList({ filter }).then((response) => {
      this.news = response;
    });
    filter = { order: 'created_at desc', limit: 4 };
    getExpList({ filter }).then((response) => {
      this.experiences = response;
    });
    talentCount().then((response) => {
      const randIndex = Math.floor(Math.random() * (response.count - 4));
      filter = { offset: Math.max(0, randIndex), limit: 4, include: ['institute_of_talent'] };
      getTalentList({ filter }).then((talents) => {
        this.talentList = talents.sort(() => Math.random() - 0.5);
      });
    });
  },
  mounted() {
    store.commit('setLoadingState', { status: true });
    window.addEventListener('scroll', this.sideMenuOnScroll);
    // const cxt = this;

    // setTimeout(() => {
    // const settings =
    const oScroll = OverlayScrollbars(document.querySelector('.news-wrapper'), this.settings);
    document.querySelector('.scroll-left').addEventListener('click', () => oScroll.scroll({ x: '-= 324px' }));
    document.querySelector('.scroll-right').addEventListener('click', () => oScroll.scroll({ x: '+= 324px' }));

    // settings.scrollbars.autoHide = 'leave';
    // settings.scrollbars.autoHideDelay = 200;
    // delete settings.callbacks;
    // settings.callbacks.onInitialized = function () {
    //   document.querySelector('.os-viewport').addEventListener('mousedown', cxt.mouseDownHandler);
    //   store.commit('setLoadingState', { status: false });
    //   store.commit('setInfiniteLoading', { status: false });
    // };
    // this.mainLoadHandler();
    // this.isLoading = false;
    // }, 1000);

    // side menu click event
    const menuItems = document.querySelectorAll('.lv1 a');
    menuItems.forEach((mi) => mi.addEventListener('click', (e) => {
      const yOffset = -170;
      const element = document.querySelector(e.target.getAttribute('href'));
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }));
  },
  unmounted() {
    window.removeEventListener('scroll', this.sideMenuOnScroll);
  },
};
</script>

<style lang="stylus" scoped>
.home
  padding-bottom: 60px;

#home-banner
  background-color: #ECEEEF;
  // background: linear-gradient(101.72deg, #73A09C 17.19%, #B6CFCC 88.74%);
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  margin-bottom: 120px;

  #main
    will-change: transform;
    transform: perspective(300px) rotateX(0) rotateY(0);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin-top: 14vh;
    width: 70%;

  #deco
    top: calc(50vh - 30%);
    left: calc(50vw + 20%);
    z-index: 100;

    img
      will-change: transform;
      transform: perspective(500px) rotateX(25deg) translateZ(20px) translateZ(20px);
      width: 20vmax;
      height: auto;

  #scroll-hint
    margin-bottom: 16px;

    // transform: translateZ(5px) translateX(-10%) translateY(-10%);
    img
      width: 36px;
      height: 12px;

.news-wrapper
  cursor: grab;

@media screen and (max-width: 991.5px)
  #home-banner
    margin-bottom: 40px;

.call-to-action
  background-color: $contract1;
  border-radius: 100px;
  margin-bottom: 16px;
  padding: 12px 12px 12px 20px;

.tag-link
  background-color: $monoc4;
  color: $monoc1;
  border-radius: 100px;
  padding: 8px 8px 8px 12px;
  text-decoration: none;
  margin-left: 16px;

  img
    width: 24px;

.fixed
  position: sticky !important;
  top: 200px;
  // top: 0;
  // padding-left: 16px;
  // margin-right: -16px;

// #news
// overflow-x: auto;
// max-width: 100%;
// .card + .card
// margin-left: 36px;
section + section
  margin-top: 114px;

.row.row-grid [class*='col-'] + [class*='col-']
  margin-top: 36px;

.news-wrapper
  padding-bottom: 24px;
  white-space: nowrap;
  margin-left: calc((var(--bs-gutter-x) / -2));

#news
  width: 100%;
  position: relative;

@media screen and (min-width: 992px)
  #news
    &:after, &.left-fade:before
      content: '';
      position: absolute;
      z-index: 1;
      bottom: 30px;
      pointer-events: none;
      background-image: linear-gradient(to right, rgba(244, 243, 238, 0) 0, rgba(244, 243, 238, 1) 70%);
      width: 50px;
      height: 100%;

    &:after
      right: -15px;
      background-image: linear-gradient(to right, rgba(244, 243, 238, 0) 0, rgba(244, 243, 238, 1) 70%);

    &.left-fade:before
      left: -15px;
      background-image: linear-gradient(to left, rgba(244, 243, 238, 0) 0, rgba(244, 243, 238, 1) 70%);

.news-article
  width: 360px;
  // padding-right: calc(var(--bs-gutter-x)/2);
  // padding-left: calc(var(--bs-gutter-x)/2);

@media (max-width: 767.5px)
  .news-article
    width: 300px;

  .news-wrapper
    padding-right: 15px;

#share
  .card-body
    padding: 24px;

  .card-text
    height: 320px;
    margin: 24px 12px 24px 24px;
    padding-right: 15px;
    overflow-y: scroll;

  .exp-img
    height: 240px;
    width: 100%;
    border-radius: 20px;
    background-size: cover;
    background-position: center;
    margin-bottom: 32px;

  .block-wrap
    border: 1px solid #BCB8B1;
    border-radius: 20px;
    overflow: hidden;

@media (min-width: 768px)
  .row.row-grid [class*='col-']:nth-child(2)
    margin-top: 0;

// @media screen and (min-width: 576px)
// #news
// width: 100%
// .news-article
// width: 360px
// @media screen and (min-width: 775px)
// #news
// width: calc(300px * 2.35);
// .news-article
// width: 300px;
// @media screen and (min-width: 992px)
// #news
// width: calc(100% + 480px * .05);
// .news-article
// width: calc(480px * .65);
// @media screen and (min-width: 1200px)
// #news
// width: calc(100% + 570px * .05);
// .news-article
// width: calc(570px * .67);
// @media screen and (min-width: 1400px)
// #news
// width: calc(100% + 660px * .05);
// // width: calc((100vw - 1320px) / 2 + 1320px * 0.75 - 0.75rem * 3 - 3px);
// .news-article
// width: calc(660px * .68);
// @media screen and (min-width: 1600px)
// #news
// width: calc(100% + 660px/3 * .68);
@media screen and (max-width: 767.5px)
  #home-banner
    #main
      background-size: contain;
      margin-top: 15vh;
      width: 120%;

    .call-to-action
      background: none;

      *
        font-size: 18px !important;
        // color: $monoc1;

      .tag-link
        margin-bottom: 8px;

@media screen and (max-width: 575.5px)
  #home-banner
    height: 83vh;

    #deco
      transform: translate3d(-4vw, 4vh, 0);

    #main
      // background-size: 150% auto;
      margin-top: 20vh;
      transform: translateY(5vh);
</style>

<style lang="stylus">
.os-host-overflow-y
  padding-right: 12px !important;

.os-scrollbar-vertical
  top: 10px !important;
  bottom: 10px !important;
</style>

<style lang="stylus">
.os-scrollbar-horizontal
  width: calc(100% - 84px);
  padding-top: 10px;

.arrows
  position: absolute;
  bottom: -10px;
  right: 0;

.scroll-btn
  // position: fixed;
  background-color: $monoc2;
  border-radius: 50%;
  border: none;
  width: 30px;
  height: 30px;

  + .scroll-btn
    margin-left: 8px;
</style>
